import React from "react";
import { Navigate } from "react-router-dom";
import LoginModal from "components/loginModal/LoginModal";

export const WithAuthorization = ({ children }) => {
    const isLogin = localStorage.getItem("jwt");
    return isLogin ? children : <Navigate to="/" />;
};

export const WithoutAuthorization = ({ children, restricted }) => {
    const isLogin = localStorage.getItem("jwt");
    return isLogin && restricted ? <Navigate to="/" /> : children;
};

// 오픈이노베이션 로그인 체크
export const OpenInnovationWithAuthorization = ({ children }) => {
    const isLogin = localStorage.getItem("jwt");
    return isLogin ? children : <LoginModal />;
};
